<template>
    <div class="flex flex-col mx-auto w-1/4 max-lg:w-full lg:mt-12 items-center justify-center">
      <img class="h-[8em]" src="../assets/svg.svg" alt="">
      <p class="text-center text-xl font-medium mt-4">Nenhum resultado encontrado</p>
    </div>
</template>

<style>
  @media (min-width: 1024px) { 
    .app{
      height: 5rem;
    }
   }


  #title{
    margin-right: 20px;
  }
  
</style>

<script>
    export default {
      name: 'noResultLogo',
    }

</script>